<div class="export-proposal-container d-flex flex-column">
  @if (proposalStatus) {
  <div class="export-proposal-content">
    <div class="pro-cont-first">
      @if (proposalLink) {
        <p>{{ statusMessage | translate }}</p>
        <p><a [href]="proposalLink" target="_blank" class="proposal-link">{{ 'COMMON_CLICK_HERE' | translate }}</a> {{ 'EXPORT_TO_PROPOSAL_VIEW_EDIT' | translate }}</p>
      } @else {
        <div class="pro-cont">
          <mat-icon class="error-icon">cancel</mat-icon>
          <div>
            <p class="invalid-pgt-title">{{'EXPORT_TO_PROPOSAL_GENERATION_FAILED_MESSAGE' | translate}}</p>
            @if (errorCode) {
              <p class="error-code-text">{{'PROPOSAL_ERROR_CODE_PREFIX' | translate}}{{ errorCode }}</p>
            }
            <p>{{ statusMessage }}</p>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="d-flex justify-content-end export-proposal-footer">
    <button type="button" mat-raised-button color="primary" (click)="onOkClick()">{{ 'OK_BTN_LABEL' | translate }}</button>
  </div>
  } @else if (invalidPGTAccounts.length > 0) {
  <div class="export-proposal-content">
    <div class="pro-cont invalid-pgt-section">
      <mat-icon class="error-icon">cancel</mat-icon>
      <div>
        <p class="invalid-pgt-title">{{'EXPORT_TO_PROPOSAL_GENERATION_FAILED_MESSAGE' | translate}}</p>
        <p class="invalid-pgt-error-code">{{'EXPORT_TO_PROPOSAL_INVALID_PGT_ERROR_CODE' | translate}}</p>
        <p>{{'EXPORT_TO_PROPOSAL_INVALID_PGT_MESSAGE' | translate}}</p>
        <p>{{'EXPORT_TO_PROPOSAL_INVALID_PGT_MYIT_MESSAGE' | translate}}</p>
        <ul class="invalid-pgt-list">
          @for (account of invalidPGTAccounts; track account) {
            <li>{{account}} [ {{ getAccountName(account) }} ]</li>
          }
        </ul>
        <p>{{'EXPORT_TO_PROPOSAL_INVALID_PGT_RETRY_MESSAGE' | translate}}</p>
        <p>{{'EXPORT_TO_PROPOSAL_INVALID_PGT_CANCEL_MESSAGE' | translate}}</p>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end export-proposal-footer">
    <button type="button" mat-raised-button color="primary" (click)="onResendWithInvalidPGT()">{{ 'EXPORT_TO_PROPOSAL_INVALID_PGT_RESEND' | translate }}</button>
    <button type="button" mat-raised-button color="warn" (click)="onCancelInvalidPGT()">{{ 'COMMON_DIALOGS_BTN_LABELS.NO' | translate }}</button>
  </div>
  } @else {
  <div class="export-proposal-content">
    @if (showAltContent) {
    <div class="pro-cont">
      <mat-icon color="warn" class="warn-icon">warning</mat-icon>
      <div>
        <p>{{'EXPORT_TO_PROPOSAL_DIALOGBOX_DATA_2' | translate}}</p>
        <p>
          <span class="proposal-link" (click)="openSolEstimate()">{{('COMMON_CLICK_HERE' | translate)}}</span>
          {{('COMMON_CLICK_HERE_TO_CHANGE_PROPOSAL_SETTINGS' | translate)}}
        </p>
      </div>
    </div>
    @if (isRestrictionTypeSet) {
    @if (!isOpportunityLinked) {
    <div class="selected-type">
      <span>{{('RESTRICTION_TYPE' | translate)}}: {{restrictionType}} </span>
      <mat-icon class="cross-icon" aria-hidden="false" aria-label="close" fontIcon="close"
        (click)="hideRestrictionType()"></mat-icon>
    </div>
    }
    }
    } @else {
    <div class="pro-cont">
      <mat-icon color="warn" class="warn-icon">warning</mat-icon>
      <div>
        <p class="m-0">{{('EXPORT_TO_PROPOSAL_DIALOGBOX_DATA_1' | translate)}}</p>
        <p class="m-0 restriction-group">
          <label class="m-r-10">{{('RESTRICTION_TYPE' | translate)}}:</label>
          <mat-radio-group [ngModel]="restrictionType" (change)="onRestrictionTypeChange($event.value)" color="primary">
            <mat-radio-button class="m-r-15" value="Restricted">{{('RESTRICTED' | translate)}}</mat-radio-button>
            <mat-radio-button value="Unrestricted">{{('UNRESTRICTED' | translate)}}</mat-radio-button>
          </mat-radio-group>
        </p>
      </div>
    </div>
    }
  </div>

  <div class="d-flex justify-content-end export-proposal-footer">
    <button type="button" mat-raised-button color="primary" (click)="onExportToProposal()">
      {{ !showAltContent ? ('OK_BTN_LABEL' | translate) : ('COMMON_DIALOGS_BTN_LABELS.YES' | translate)}}
    </button>
    <button type="button" mat-raised-button color="warn" (click)="closeDialogEvent.emit()">
      {{ !showAltContent ? ('CANCEL_BTN_LABEL' | translate) : ('COMMON_DIALOGS_BTN_LABELS.NO' | translate)}}
    </button>
  </div>
  }
</div>